import React from "react"
import PropTypes from "prop-types"
import { Header, WrapperSizes } from "components"

import Form from "./Form"
import ContactDetails from "./ContactDetails"
import S from "./ContactContent.styled"

const ContactContent = ({
  contactDetails,
  contactForm,
  address,
  title,
  _ref,
}) => (
  <S.StyledWrapper size={WrapperSizes.SMALL} _ref={_ref}>
    <S.Wrapper>
      <Header title={title} id="contactTitle" />
      <S.InnerWrapper id="contactContent">
        <ContactDetails contact={contactDetails} address={address} />
        <Form details={contactForm} />
      </S.InnerWrapper>
    </S.Wrapper>
  </S.StyledWrapper>
)

ContactContent.propTypes = {
  title: PropTypes.string.isRequired,
}

export default ContactContent
